import CustomSchedulerSlot from "@/components/kendo/scheduler/custom-scheduler-slot";

export default function CustomSchedulerSlotMonth(props: any) {
    return CustomSchedulerSlot({ ...props, monthView: true });
}